import type { ReactNode } from "react";
import { useCampaignPerformanceQuery } from "../../../hooks/useCampaignPerformanceQuery";
import { useAirlinesCampaignPerformanceQuery } from "../../../hooks/useAirlinesCampaignPerformanceQuery";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { useAuth } from "../../../hooks/useAuth";
import { METRIC_NAMES } from "../../../constants";
import { PageEmptyState } from "../PageEmptyState";

type ChartsDataGuardProps = {
  from: Date;
  to: Date;
  children: ReactNode;
};

export const ChartsDataGuard = ({ from, to, children }: ChartsDataGuardProps) => {
  const { isAirlineUser } = useAuth();
  const useQuery = isAirlineUser ? useCampaignPerformanceQuery : useAirlinesCampaignPerformanceQuery;
  const { selectedAirline } = useSelectedAirline({ useSuspense: true });
  const { data: metrics } = useQuery({
    from,
    to,
    metrics: [...METRIC_NAMES],
    airlineCode: selectedAirline?.code,
  });

  if (metrics.length === 0) {
    return <PageEmptyState />;
  }

  return <>{children}</>;
};
